// Module
var code = "<select chosen disable-search=\"true\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.change({ size: $ctrl.selected })\" ng-options=\"val as val for val in $ctrl.values\"> </select> ";
// Exports
module.exports = code;